// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-panel-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 22px 24px 28px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

/* 전역 Login.css의 button 규칙(width:100% + 보라 그라디언트)이 새는 것을 차단.
   admin 영역 내 모든 버튼의 폭을 자동으로, 누수된 그라디언트를 제거한다. */
.admin-panel-container button {
  width: auto;
  background-image: none;
}

/* ── 헤더 ── */
.admin-panel-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eef0f2;
}

.admin-panel-header h2 {
  margin: 0;
  color: #212529;
  font-size: 22px;
  font-weight: 700;
  flex: 1 1;
  white-space: nowrap;
}

/* 뒤로가기 버튼(공통 .back-btn 위에 덧입힘) */
.admin-panel-container .back-btn {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background: #fff;
  color: #495057;
  font-size: 18px;
  cursor: pointer;
}

.admin-panel-container .back-btn:hover {
  background: #f1f3f5;
}

/* ── 사용자 관리 섹션 ── */
.users-section {
  margin-bottom: 24px;
}

.users-section h3 {
  color: #343a40;
  font-size: 17px;
  font-weight: 700;
  white-space: nowrap;
}

/* 생성 버튼 (+ 생성) — 전역 누수 차단 후 solid */
.users-section .btn-primary {
  background-color: #1971c2;
  border-color: #1971c2;
  border-radius: 8px;
}

.users-section .btn-primary:hover:not(:disabled) {
  background-color: #1864ab;
  border-color: #1864ab;
}

/* ── 테이블 ── */
.users-table-container {
  overflow-x: auto;
  border: 1px solid #e9ecef;
  border-radius: 10px;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.users-table th,
.users-table td {
  padding: 11px 14px;
  text-align: left;
  border-bottom: 1px solid #f1f3f5;
  white-space: nowrap;          /* 이름 등 셀 내용 줄바꿈 방지 */
  vertical-align: middle;
}

.users-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #495057;
  font-size: 13px;
  letter-spacing: 0.01em;
}

.users-table td {
  color: #212529;
  font-size: 14px;
}

.users-table tbody tr:last-child td {
  border-bottom: none;
}

.users-table tbody tr:hover {
  background: #f8fafd;
}

/* 이름 셀: 이름 + 연필 아이콘 정렬 */
.users-table td .name-cell,
.users-table td > div {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* 셀렉트(권한/상태) 공통 */
.level-select,
.status-select {
  padding: 6px 10px;
  border: 1px solid #ced4da;
  border-radius: 7px;
  font-size: 13px;
  background: #fff;
  color: #212529;
  cursor: pointer;
}

.level-select:disabled,
.status-select:disabled {
  background: #f1f3f5;
  color: #adb5bd;
  cursor: not-allowed;
}

/* 이름 수정 저장/취소 버튼 */
.name-edit-action {
  padding: 3px 9px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;
}

.name-edit-action.save {
  background: #2b8a3e;
  color: #fff;
}

.name-edit-action.save:hover {
  background: #237032;
}

.name-edit-action.cancel {
  background: #f1f3f5;
  color: #495057;
  border-color: #dee2e6;
}

.name-edit-action.cancel:hover {
  background: #e9ecef;
}

/* ── 작업 버튼 (비밀번호 초기화 / 삭제) ── */
.reset-password-btn,
.delete-user-btn {
  padding: 6px 12px;
  border-radius: 7px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s, border-color 0.15s;
}

/* 비밀번호 초기화 — 아웃라인(덜 파괴적) */
.reset-password-btn {
  background: #fff;
  color: #e8590c;
  border: 1px solid #ffc9a3;
}

.reset-password-btn:hover:not(:disabled) {
  background: #fff4ec;
  border-color: #ff922b;
}

.reset-password-btn:disabled {
  background: #f1f3f5;
  color: #adb5bd;
  border-color: #e9ecef;
  cursor: not-allowed;
}

/* 삭제 — solid danger */
.delete-user-btn {
  background-color: #e03131 !important;   /* 인라인/전역 위로 확실히 */
  color: #fff;
  border: 1px solid #e03131;
}

.delete-user-btn:hover:not(:disabled) {
  background-color: #c92a2a !important;
  border-color: #c92a2a;
}

.delete-user-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* 상태 뱃지(사용되는 경우) */
.status-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  display: inline-block;
  min-width: 56px;
}

.status-badge.normal {
  background: #d3f9d8;
  color: #2b8a3e;
}

.status-badge.inactive {
  background: #ffe3e3;
  color: #c92a2a;
}

/* ── 관리자 안내 ── */
.admin-info {
  margin-top: 24px;
  background: #f8f9fa;
  padding: 18px 22px;
  border-radius: 12px;
  border: 1px solid #eef0f2;
  text-align: left;
}

.admin-info h4 {
  margin: 0 0 12px;
  color: #343a40;
  font-size: 15px;
  font-weight: 700;
  text-align: left;
}

.admin-info ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 6px 20px;
}

.admin-info li {
  position: relative;
  padding-left: 20px;
  color: #6c757d;
  font-size: 13px;
  line-height: 1.6;
  text-align: left;
}

.admin-info li::before {
  content: '✓';
  position: absolute;
  left: 0;
  top: 0;
  color: #1971c2;
  font-weight: 700;
}

@media (max-width: 768px) {
  .admin-panel-container {
    margin: 10px;
    padding: 16px 14px 22px;
  }

  .users-table th,
  .users-table td {
    padding: 9px 10px;
    font-size: 13px;
  }

  .admin-info ul {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminPanel.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;gDACgD;AAChD;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB,WAAW,qBAAqB;EACnD,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kBAAkB;AAClB;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,oCAAoC,IAAI,kBAAkB;EAC1D,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,4DAA4D;EAC5D,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".admin-panel-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 22px 24px 28px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n}\n\n/* 전역 Login.css의 button 규칙(width:100% + 보라 그라디언트)이 새는 것을 차단.\n   admin 영역 내 모든 버튼의 폭을 자동으로, 누수된 그라디언트를 제거한다. */\n.admin-panel-container button {\n  width: auto;\n  background-image: none;\n}\n\n/* ── 헤더 ── */\n.admin-panel-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #eef0f2;\n}\n\n.admin-panel-header h2 {\n  margin: 0;\n  color: #212529;\n  font-size: 22px;\n  font-weight: 700;\n  flex: 1;\n  white-space: nowrap;\n}\n\n/* 뒤로가기 버튼(공통 .back-btn 위에 덧입힘) */\n.admin-panel-container .back-btn {\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  background: #fff;\n  color: #495057;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.admin-panel-container .back-btn:hover {\n  background: #f1f3f5;\n}\n\n/* ── 사용자 관리 섹션 ── */\n.users-section {\n  margin-bottom: 24px;\n}\n\n.users-section h3 {\n  color: #343a40;\n  font-size: 17px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n/* 생성 버튼 (+ 생성) — 전역 누수 차단 후 solid */\n.users-section .btn-primary {\n  background-color: #1971c2;\n  border-color: #1971c2;\n  border-radius: 8px;\n}\n\n.users-section .btn-primary:hover:not(:disabled) {\n  background-color: #1864ab;\n  border-color: #1864ab;\n}\n\n/* ── 테이블 ── */\n.users-table-container {\n  overflow-x: auto;\n  border: 1px solid #e9ecef;\n  border-radius: 10px;\n}\n\n.users-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n}\n\n.users-table th,\n.users-table td {\n  padding: 11px 14px;\n  text-align: left;\n  border-bottom: 1px solid #f1f3f5;\n  white-space: nowrap;          /* 이름 등 셀 내용 줄바꿈 방지 */\n  vertical-align: middle;\n}\n\n.users-table th {\n  background: #f8f9fa;\n  font-weight: 600;\n  color: #495057;\n  font-size: 13px;\n  letter-spacing: 0.01em;\n}\n\n.users-table td {\n  color: #212529;\n  font-size: 14px;\n}\n\n.users-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.users-table tbody tr:hover {\n  background: #f8fafd;\n}\n\n/* 이름 셀: 이름 + 연필 아이콘 정렬 */\n.users-table td .name-cell,\n.users-table td > div {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* 셀렉트(권한/상태) 공통 */\n.level-select,\n.status-select {\n  padding: 6px 10px;\n  border: 1px solid #ced4da;\n  border-radius: 7px;\n  font-size: 13px;\n  background: #fff;\n  color: #212529;\n  cursor: pointer;\n}\n\n.level-select:disabled,\n.status-select:disabled {\n  background: #f1f3f5;\n  color: #adb5bd;\n  cursor: not-allowed;\n}\n\n/* 이름 수정 저장/취소 버튼 */\n.name-edit-action {\n  padding: 3px 9px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\n.name-edit-action.save {\n  background: #2b8a3e;\n  color: #fff;\n}\n\n.name-edit-action.save:hover {\n  background: #237032;\n}\n\n.name-edit-action.cancel {\n  background: #f1f3f5;\n  color: #495057;\n  border-color: #dee2e6;\n}\n\n.name-edit-action.cancel:hover {\n  background: #e9ecef;\n}\n\n/* ── 작업 버튼 (비밀번호 초기화 / 삭제) ── */\n.reset-password-btn,\n.delete-user-btn {\n  padding: 6px 12px;\n  border-radius: 7px;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background-color 0.15s, border-color 0.15s;\n}\n\n/* 비밀번호 초기화 — 아웃라인(덜 파괴적) */\n.reset-password-btn {\n  background: #fff;\n  color: #e8590c;\n  border: 1px solid #ffc9a3;\n}\n\n.reset-password-btn:hover:not(:disabled) {\n  background: #fff4ec;\n  border-color: #ff922b;\n}\n\n.reset-password-btn:disabled {\n  background: #f1f3f5;\n  color: #adb5bd;\n  border-color: #e9ecef;\n  cursor: not-allowed;\n}\n\n/* 삭제 — solid danger */\n.delete-user-btn {\n  background-color: #e03131 !important;   /* 인라인/전역 위로 확실히 */\n  color: #fff;\n  border: 1px solid #e03131;\n}\n\n.delete-user-btn:hover:not(:disabled) {\n  background-color: #c92a2a !important;\n  border-color: #c92a2a;\n}\n\n.delete-user-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* 상태 뱃지(사용되는 경우) */\n.status-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  display: inline-block;\n  min-width: 56px;\n}\n\n.status-badge.normal {\n  background: #d3f9d8;\n  color: #2b8a3e;\n}\n\n.status-badge.inactive {\n  background: #ffe3e3;\n  color: #c92a2a;\n}\n\n/* ── 관리자 안내 ── */\n.admin-info {\n  margin-top: 24px;\n  background: #f8f9fa;\n  padding: 18px 22px;\n  border-radius: 12px;\n  border: 1px solid #eef0f2;\n  text-align: left;\n}\n\n.admin-info h4 {\n  margin: 0 0 12px;\n  color: #343a40;\n  font-size: 15px;\n  font-weight: 700;\n  text-align: left;\n}\n\n.admin-info ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 6px 20px;\n}\n\n.admin-info li {\n  position: relative;\n  padding-left: 20px;\n  color: #6c757d;\n  font-size: 13px;\n  line-height: 1.6;\n  text-align: left;\n}\n\n.admin-info li::before {\n  content: '✓';\n  position: absolute;\n  left: 0;\n  top: 0;\n  color: #1971c2;\n  font-weight: 700;\n}\n\n@media (max-width: 768px) {\n  .admin-panel-container {\n    margin: 10px;\n    padding: 16px 14px 22px;\n  }\n\n  .users-table th,\n  .users-table td {\n    padding: 9px 10px;\n    font-size: 13px;\n  }\n\n  .admin-info ul {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
